import React from 'react'
import { Box, Grid, Select, MenuItem, Checkbox } from '@material-ui/core'
import InputLabel from '@material-ui/core/InputLabel'
import { FormControl, FormControlLabel } from '@material-ui/core'
import styled from 'styled-components'

import { FontType } from '../redux/cardAttributeModelIndex';
import { deepCopy } from '../general';
import ColorPalette from './ColorPalette'

const ItemFormControl = styled(FormControl)`
  width: 40%;
  margin-right: 3px;
`
const ColorLabel = styled.label`
  margin-right: 8px;
`

type EditItemFontProps = {
  kind: 'single' | 'multi' | 'table' | 'text' | 'uiInput' | 'uiText' | 'uiTextLabel'| 'uiButton' | 'drawText';
  font: FontType;
  setFont?: (font: FontType) => void;
  onUpdate?: (font: FontType) => void;
}
const EditItemFont: React.FC<EditItemFontProps> = ({kind, font, setFont, onUpdate}) => {
  type keyObjType = { [key in string]: string };
  const fontNames = ['MS PGothic', 'MS PMincho', 'Hiragino Maru Gothic Pro'];
  const fontSizes = [7,8,9,10,12,14,16,18,20,24,28,32];
  const fontDirections: keyObjType = { 'vertical-rl': '縦書き', 'horizontal-tb': '横書き' };
  const fontOrientations: keyObjType = { 'mixed': '混在', 'upright': '正立', 'sideways': '側転' };
  const fontYokos: keyObjType = { 'left': '左寄せ', 'center': '中央', 'right': '右寄せ' };
  const fontTates: keyObjType = { 'start': '上寄せ', 'center': '中央', 'end': '下寄せ' };

  const changeFont = (newFont: FontType) => {
    if (setFont) setFont(newFont);
    if (onUpdate) onUpdate(newFont);
  }
  const handleChangeBold = (ev: any) => {
    let newFont = deepCopy(font);
    newFont.bold = ev.target.checked;
    changeFont(newFont);
  }
  const handleChangeItalic = (ev: any) => {
    let newFont = deepCopy(font);
    newFont.italic = ev.target.checked;
    changeFont(newFont);
  }
  const handleChangeUnderline = (ev: any) => {
    let newFont = deepCopy(font);
    newFont.underline = ev.target.checked;
    changeFont(newFont);
  }
  const handleChangeAutoFit = (ev: any) => {
    let newFont = deepCopy(font);
    newFont.autoFit = ev.target.checked;
    changeFont(newFont);
  }
  const handleChangeFontName = (ev: any) => {
    let newFont = deepCopy(font);
    newFont.name = ev.target.value;
    changeFont(newFont);
  }
  const handleChangeColor = (value: string) => {
    let newFont = deepCopy(font);
    newFont.color = value;
    changeFont(newFont);
  }
  const handleChangeSize = (ev: any) => {
    let newFont = deepCopy(font);
    newFont.size = ev.target.value;
    changeFont(newFont);
  }
  const handleChangeYoko = (ev: any) => {
    let newFont = deepCopy(font);
    newFont.yoko = ev.target.value;
    changeFont(newFont);
  }
  const handleChangeTate = (ev: any) => {
    let newFont = deepCopy(font);
    newFont.tate = ev.target.value;
    changeFont(newFont);
  }
  const handleChangeDirections = (ev: any) => {
    let newFont = deepCopy(font);
    newFont.direction = ev.target.value;
    changeFont(newFont);
  }
  const handleChangeOrientation = (ev: any) => {
    let newFont = deepCopy(font);
    newFont.orientation = ev.target.value;
    changeFont(newFont);
  }

  return (
    <Box>
      {(kind === 'single' || kind === 'multi' || kind === 'table' || kind === 'text' || kind === 'drawText') && 'フォント'}
      {(kind === 'uiInput' || kind === 'uiButton') && 'ラベルフォント'}
      {kind === 'uiText' && 'テキストフォント'}
      {kind === 'uiTextLabel' && 'ラベルフォント'}
      <Box mt={1}>
        { (kind === 'single' || kind === 'multi' || kind === 'table' || kind === 'text' || kind === 'uiText' || kind === 'drawText') &&
          <ItemFormControl variant='outlined'>
            <InputLabel id={'name_switch'}>フォント名</InputLabel>
            <Select labelId={'name_switch'} id={'name_switch'} label='フォント名'
              value={font.name} onChange={handleChangeFontName}
            >
              {fontNames.map((fontName, ix) => (
                <MenuItem value={fontName} key={ix}>{fontName}</MenuItem>
              ))}
            </Select>
          </ItemFormControl>
        }
      </Box>
      <Grid container style={{marginTop: '8px'}} alignItems="center" spacing={2}>
        <Grid item xs={6}>
        <ItemFormControl variant='outlined' style={{width: '100%'}}>
          <InputLabel id={'size_switch'}>大きさ</InputLabel>
          <Select labelId={'size_switch'} id={'size_switch'} label='大きさ'
            value={font.size} onChange={handleChangeSize}
          >
            {fontSizes.map((fontSize, ix) => (
              <MenuItem value={fontSize} key={ix}>{fontSize}</MenuItem>
            ))}
          </Select>
        </ItemFormControl>
        </Grid>
        <Grid item xs={6}>
          <ColorPalette
            currentValue={font.color}
            onChange={handleChangeColor}
          />
        </Grid>
      </Grid>
      <Box mt={1}>
        { (kind === 'single' || kind === 'multi' || kind === 'table' || kind === 'text' || kind === 'uiInput' || kind === 'uiText' || kind === 'uiTextLabel' || kind === 'drawText') &&
          <FormControlLabel label="太字"
            control={
              <Checkbox name="checkedBold" color="default"
                checked={font.bold} onChange={handleChangeBold}
              /> }
          />
        }
        { (kind === 'single' || kind === 'multi' || kind === 'table' || kind === 'text' || kind === 'uiText' || kind === 'drawText') &&
          <FormControlLabel label="斜体"
            control={
              <Checkbox name="checkedItalic" color="default"
                checked={font.italic} onChange={handleChangeItalic}
              /> }
          />
        }
        { (kind === 'single' || kind === 'multi' || kind === 'text' || kind === 'uiText' || kind === 'drawText') &&
          <FormControlLabel label="下線"
            control={
              <Checkbox name="checkedUnderline" color="default"
                checked={font.underline} onChange={handleChangeUnderline}
              /> }
          />
        }
      </Box>
      <Box mt={1}>
        { (kind === 'single' || kind === 'multi' || kind === 'table' || kind === 'text' || kind === 'uiText') &&
          <FormControlLabel label="オートフィット"
            control={
              <Checkbox name="checkedAutoFid" color="default"
                checked={font.autoFit} onChange={handleChangeAutoFit}
              /> }
          />
        }
      </Box>
      { (kind === 'single' || kind === 'text' || kind === 'uiText') &&
        <Box mt={1}>
          <ItemFormControl variant='outlined'>
            <InputLabel id={'direction_switch'}>文字の横書き</InputLabel>
            <Select labelId={'direction_switch'} id={'direction_switch'} label='文字の横書き'
                    value={font.direction} onChange={handleChangeDirections}
              >
              {Object.keys(fontDirections).map((key, ix) => {
                return (
                  <MenuItem value={key} key={ix}>{fontDirections[key]}</MenuItem>
                );
              })}
            </Select>
          </ItemFormControl>
          <ItemFormControl variant='outlined'>
            <InputLabel id={'orientation_switch'}>縦書き時の文字の向き</InputLabel>
            <Select labelId={'orientation_switch'} id={'orientation_switch'} 
              label='縦書き時の文字の向き'
              value={font.orientation} onChange={handleChangeOrientation}
            >
              {Object.keys(fontOrientations).map((key, ix) => {
                return (
                  <MenuItem value={key} key={ix}>{fontOrientations[key]}</MenuItem>
                );
              })}
            </Select>
          </ItemFormControl>
        </Box>
      }
      { (kind === 'single' || kind === 'multi' || kind === 'table' || kind === 'text' || kind === 'uiText') &&
        <Box mt={1}>
          <ItemFormControl variant='outlined'>
            <InputLabel id={'yoko_switch'}>左右寄せ</InputLabel>
            <Select labelId={'yoko_switch'} id={'yoko_switch'} 
              label='左右寄せ'
              value={font.yoko} onChange={handleChangeYoko}
            >
              {Object.keys(fontYokos).map((key, ix) => {
                return (
                  <MenuItem value={key} key={ix}>{fontYokos[key]}</MenuItem>
                );
              })}
            </Select>
          </ItemFormControl>
          <ItemFormControl variant='outlined'>
            <InputLabel id={'tate_switch'}>上下寄せ</InputLabel>
            <Select labelId={'tate_switch'} id={'tate_switch'} 
              label='上下寄せ'
              value={font.tate} onChange={handleChangeTate}
            >
              {Object.keys(fontTates).map((key, ix) => {
                return (
                  <MenuItem value={key} key={ix}>{fontTates[key]}</MenuItem>
                );
              })}
            </Select>
          </ItemFormControl>
        </Box>
      }
    </Box>
  );
}

export default EditItemFont;
